import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { PaymentBillet } from '@ibk/pagamentos';
import styles from './Billet.module.css';
export function Billet() {
    const dataTestId = 'conta-pj-payment';
    return (_jsx("main", { className: styles.main, "data-testid": dataTestId, children: _jsx(PaymentBillet, { dataTestId: `${dataTestId}-billet-page` }) }));
}
